import React from 'react';
import PropTypes from 'prop-types';
import { i18next, dialogs, view } from '@yola/ws-sdk';
import { reactHookForm } from '@yola/ws-ui';
import ImageAltDialog from '../components/image-alt-dialog';

const { useForm } = reactHookForm;

const ALT_FIELD_NAME = 'alt';

const getCaptions = () => ({
  title: i18next.t('Change alt title'),
  label: i18next.t('Alt title'),
  description: i18next.t(
    'Search engines cannot see images but they can read their descriptions. Add image description to boost your search engine visibility.'
  ),
  submit: i18next.t('Save'),
  cancel: i18next.t('Cancel'),
});

function ImageAltContainer({ imageElement, onDialogMainAction, onDialogCancel }) {
  const captions = getCaptions();
  const currentAlt = imageElement.getAttribute('alt') || '';
  const imageElementId = view.accessors.getLiveElementId(imageElement);

  const {
    control,
    getValues,
    formState: { isDirty },
  } = useForm({
    mode: 'all',
    defaultValues: {
      [ALT_FIELD_NAME]: currentAlt,
    },
  });

  const handleSubmit = () => {
    if (isDirty) {
      const { alt } = getValues();
      const trimmedAlt = alt.trim();

      view.operations.setElementAttribute(imageElementId, ALT_FIELD_NAME, trimmedAlt);
    }

    onDialogMainAction();
    dialogs.operations.hide();
  };

  const handleCancel = () => {
    onDialogCancel();
    dialogs.operations.hide();
  };

  return (
    <ImageAltDialog
      imageElement={imageElement}
      control={control}
      altFieldName={ALT_FIELD_NAME}
      captions={captions}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
    />
  );
}

ImageAltContainer.propTypes = {
  imageElement: PropTypes.object.isRequired,
  // Passed from ws-editor's `dialogs-container`:
  onDialogMainAction: PropTypes.func.isRequired,
  onDialogCancel: PropTypes.func.isRequired,
};

export default ImageAltContainer;
